export default __webpack_public_path__ + "static/media/snapCode.93547d21.png";